import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(theme => ({
    fieldSetContainer: {
        '& input': {
            display: 'none',
        },
    },
    fieldSetLabel: {
        ...theme.typographyPresets.titleSmallLight,
        ...theme.fontColors.light,
        marginBottom: '32px',
        lineHeight: '1.25',
    },
    label: {
        display: 'inline-block',
        cursor: 'pointer',
        fontFamily: 'NotoSansBold',
        fontSize: '12px',
        lineHeight: '40px',
        borderRadius: '8px',
        height: '40px',
        marginBottom: '20px',
        width: '100%',
        textAlign: 'center',
        whiteSpace: 'nowrap',
    },
    darkContainer: {
        '& input:checked + label': getLightTheme(),
    },
    lightContainer: {
        '& input:checked + label': getDarkTheme(),
    },
    dark: getDarkTheme(),
    light: getLightTheme(),
}))

function getLightTheme() {
    return {
        backgroundColor: '#ffffff',
        color: '#000000',
        border: 'solid 1px #000000',
    }
}
function getDarkTheme() {
    return {
        backgroundColor: '#1c222e',
        color: '#ffffff',
        border: 'solid 1px #5e6675',
    }
}
